<template>
  <a>
  <div class="row">
    <div class="col-12 col-lg-2 col-xl-2">
      <p class="text-truncate">
        <span class="data-label d-lg-none">Aws Account Id:</span>
        <span class="strong"><a v-bind:href="awsLink">{{ account.aws_account_id }}</a></span>
      </p>
    </div>
    <div class="col-12 col-lg-3 col-xl-3">
      <p class="text-truncate">
        <span class="data-label d-lg-none">Name #:</span>
        <span class="strong">{{ account.name }}</span>
      </p>
    </div>
    <div class="col-12 col-lg-3 col-xl-3">
      <p class="text-truncate">
        <span class="data-label d-lg-none">Terraform Workspace Name #:</span>
        <span class="strong">{{ account.terraform_workspace_name }}</span>
      </p>
    </div>
    <div class="col-6 col-lg-2 col-xl-2 text-end">
      <p class="text-truncate">
        <span class="data-label d-lg-none">Charge:</span>
        <span
          v-bind:class="account.charge ? 'status-success' : 'status-mute'"
          class="status"
          >{{ account.charge }}</span
        >
      </p>
    </div>
    <div class="col-6 col-lg-2 col-xl-2 text-end">
      <p class="text-truncate">
        <aws-account-modal
          ref="editmodal"
          title="Edit Aws Account"
          :awsAccount="account"
          mode="edit"
        ></aws-account-modal>

        <button v-c-modal:editmodal="{ name: 'Jason' }" class="btn btn-sm">Edit</button>
        
      </p>
    </div>

  </div>
  </a>
</template>

<script>
import AwsAccountModal from "./AwsAccountModal";
export default {
  components: {
    AwsAccountModal
  },
  props: {
    account: {
      required: true,
      type: Object,
    },
  },
  computed: {
    awsLink() {
      return 'https://signin.aws.amazon.com/switchrole?roleName=OrganizationAccountAccessRole&account='+this.account.aws_account_id+'&displayName='+this.account.terraform_workspace_name+'&color=FBBF93'
    }
  }
};
</script>
